import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { STREAM_FLAG_MESSAGE } from "graphql/messaging/mutations";

import { sendAddReaction, sendRemoveReaction } from "./actions";

export default function useMessageInteraction({ messageId, channelId }) {
  const addReaction = useCallback(
    (reactionId) => sendAddReaction(channelId, messageId, reactionId),
    [channelId, messageId]
  );

  const removeReaction = useCallback(
    (reactionId) => sendRemoveReaction(channelId, messageId, reactionId),
    [channelId, messageId]
  );

  const [flagMessageMutation, { loading: flaggingMessage }] =
    useMutation(STREAM_FLAG_MESSAGE);

  const flagMessage = useCallback(
    (reason) =>
      flagMessageMutation({ variables: { input: { messageId, reason } } }),
    [flagMessageMutation, messageId]
  );

  return {
    addReaction,
    removeReaction,
    flagMessage,
    flaggingMessage,
  };
}
